<template>
    <div class="h-[calc(100vh-3.5rem)] fixed text-xs 2xl:text-sm bg-gray-50">
        <slot></slot>
    </div>
</template>

<script setup></script>